import { useContext } from "react";
import { Navigate } from "react-router";

import { UserSessionContext } from "../../use-user-context";

export type NotFoundProps = object;

export const NotFound: React.FC<NotFoundProps> = () => {
  const [session] = useContext(UserSessionContext);

  if (!session || !session.active) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="container-fluid min-vh-80 d-flex justify-content-center">
      <div className="text-center p-4 mt-3">
        <div
          className="d-inline-flex align-items-center justify-content-center rounded-circle bg-secondary mb-3"
          style={{ width: 96, height: 96, opacity: 0.5 }}
          role="img"
          aria-label="Error icon placeholder"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="48"
            height="48"
            fill="currentColor"
            className="bi bi-bug"
            viewBox="0 0 16 16"
          >
            <path d="m11.646.44.897.896-.707.707-.897-.897A.5.5 0 0 0 10.586 1H3.5a.5.5 0 0 0-.5.5v9.379l-1 1V1.5A1.5 1.5 0 0 1 3.5 0h7.086a1.5 1.5 0 0 1 1.06.44M10.5 3q.175 0 .34.039L9.879 4H8.5v1.379L6.879 7H5v1.879l-1 1V4.5A1.5 1.5 0 0 1 5.5 3zM12 6.121l-1 1V9H9.121L7.5 10.621V12H6.121l-.961.961q.165.039.34.039h5a1.5 1.5 0 0 0 1.5-1.5zM3.5 15a.5.5 0 0 1-.288-.091l-.71.71c.265.237.615.381.998.381h9a1.5 1.5 0 0 0 1.5-1.5V4.121l-1 1V14.5a.5.5 0 0 1-.5.5zm2-11a.5.5 0 0 0-.5.5V6h2.5V4zm5.5 6v1.5a.5.5 0 0 1-.5.5h-2v-2zm3.854-8.146a.5.5 0 0 0-.708-.708l-13 13a.5.5 0 0 0 .708.708z" />
          </svg>
          <span className="visually-hidden">Icon</span>
        </div>
        <h1 className="h3 fw-semibold mb-2">
          Kein Anschluß unter dieser Nummer
        </h1>
        <p className="text-muted mb-0">
          Die angegebene Seite konnte nicht gefunden werden.
        </p>
      </div>
    </div>
  );
};
